import ResourceManager from "@/components/admin/ResourceManager";

export default function ServicesAdmin() {
  return (
    <ResourceManager
      collection="services" title="Services" subtitle="Gérez vos prestations informatiques."
      aiKind="service"
      columns={[
        { key: "name", label: "Nom" },
        { key: "category", label: "Catégorie" },
      ]}
      fields={[
        { name: "name", label: "Nom", type: "text" },
        { name: "category", label: "Catégorie", type: "select", options: ["Développement", "Infrastructure", "Sécurité", "Support", "Conseil"] },
        { name: "icon", label: "Icône", type: "select", options: ["code", "smartphone", "network", "shield", "wrench", "server", "graduation-cap"] },
        { name: "short_desc", label: "Description courte", type: "textarea" },
        { name: "description", label: "Description détaillée", type: "richtext", ai: true, aiFrom: "name" },
        { name: "prestations", label: "Prestations", type: "list" },
        { name: "image", label: "Image (URL)", type: "text" },
        { name: "seo_title", label: "SEO — Meta title", type: "text" },
        { name: "seo_description", label: "SEO — Meta description", type: "textarea" },
        { name: "seo_keywords", label: "SEO — Mots-clés", type: "text" },
      ]}
    />
  );
}
